import React, { useState, useRef, useEffect } from "react"

import "./PatientProfile.css"
import "../Commons/Commons.css"
import "chart.js/auto"

import backarrow from "../../Assets/Icons/back-arrow.png"
import SidebarMenu from "../Sidebar/Sidebar"
import PatientCard from "./PatientCard"
import BtnSave from "../Commons/Buttons/BtnSave"
import Laboratory from "../Laboratory/Laboratory"
import AssessmentHistory from "../AssessmentHistory/AssessmentHistory"
import Radiology from "../Radiology/Radiology"
import Xray from "../Radiology/Xray"
import Ultrasound from "../Radiology/Ultrasound"
import CTScan from "../Radiology/CTScan"
import Others from "../Radiology/Others"
import HealthScreening from "../HealthScreening/HealthScreening"
import PatientScannedProfile from "../PatientScannedFiles/PatientScannedFiles"
import AddMedical from "../MedicalHistory/AddMedical"
import { createQueueSlipFile } from "../QueueSlip/QueueSlipUtils"
import QueueSlip from "../QueueSlip/QueueSlip"
import { handleApiPrint } from "../Helpers/PrintUtils"
import MedicalAbstract from "../Forms/MedicalAbstract/MedicalAbstract"
import MedicalSummary from "../Forms/MedicalSummary/MedicalSummary"
import TheraputicsHistory from "../Theraputics/TheraputicsHistory"
import LaboratoryResults from "../Laboratory/LaboratoryResults"
import MedicalChart from "../MedicalChart/MedicalChart"
import CheckupTabs from "../../Pages/CheckupTabs/CheckupTabs"
import { PhilHealthMedicalRecord } from "../PhilHealth/MedicalRecord"
import { KonsultaManager } from "../PhilHealth/KonsultaManager"
import AddSocialPersonal from "../SocialPersonalHistory/AddSocialPersonal";
// import LaboratoryTabs from "../Laboratory/LaboratoryTabs";
import AppointmentModal from "../Modals/AppointmentModal"
import AddToQueueModal from "../Modals/AddToQueueModal"
import RoutingSlipModal from "../Modals/RoutingSlipModal"
import VitalSigns from "./VitalSigns"
import PhysicalExaminationYakap from "../PEYakap/PhysicalExaminationYakap"
import DeleteModal from "../Modals/DeleteModal"
import MedicalCertificateForm from "../Forms/MedicalCertificate/MedicalCertificateForm"
import ReferralLetterForm from "../Forms/ReferralLetter/ReferralLetterForm"
import AllergyCard from "./AllergyCard"
import FormHistory from "../Forms/FormHistory/FormHistory"
import TableSpinner from "../../Components/TableSpinner/TableSpinner"
import { getLabCategoriesQR } from "../Helpers/API/QrDiagnosticsApi/QrDiagnosticsApi";
import LabResultPage from "../Laboratory/LabResultPage";
import BirForm from "../AssessmentHistory/PrintEkas";
import { getAssessmentForPrint, uploadEkasDocument } from "../Helpers/API/AssessmentApi/AssessmentApi";
import html2pdf from "html2pdf.js";
import { Alert, Row, Col, Modal } from "react-bootstrap"
import BtnDelete from "../Commons/Buttons/BtnDelete"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { Card } from "antd"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import {
  deletePatient,
  getPatientID,
} from "../Helpers/API/PatientApi/PatientApi"
import { getAllDoctors } from "../Helpers/API/DoctorApi/DoctorApi"
import { createSchedule } from "../Helpers/API/FollowUpPatientsApi/FollowUpPatientsApi"
import { toast } from "react-toastify"
import {
  getQueuedPatients,
  setFPEDone,
  createBookings,
} from "../Helpers/API/QueueApi/QueueApi"
import { createPayment, generateReceipt } from "../Helpers/API/PaymentApi/PaymentApi"
import {
  getIsCheck,
  getOpenAppointmentModal,
  getRole,
  getTomorrowDate,
  getUser,
  getAge,
} from "../Helpers/Utilities/Common"
import { getAssessmentHistory } from "../Helpers/API/AssessmentApi/AssessmentApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons"
import {
  getAllergy,
  getPastMedicalHistory,
  getHeredofamilial,
} from "../Helpers/API/MedicalHistoryApi/MedicalHistoryApi"
import {
  getMedicalHistorySummary,
  getSocialPersonalHistorySummary,
} from "../Helpers/API/ReportsApi/ReportsApi"
import { Tabs } from "antd"

const { TabPane } = Tabs

const FAMILY_PROFILE_NAMES = new Set([
  "Family Past Medical History Profile",
  "Heredofamilial Disease Profile",
  "Family Cancer Profile",
  "Family Hepatitis Profile",
  "Family Pulmonary Tuberculosis Profile",
  "Family Extrapulmonary Tuberculosis Profile",
])

const SOCIAL_PROFILE_NAMES = new Set([
  "Smoking Profile",
  "Drinking Profile",
  "Herbal Use Profile",
  "Drug Use Profile",
  "Sexual Activity Profile",
])
function PatientProfile() {
  const role = getRole()
  // const isTrue = getIsTrue();
  const openAppointment = getOpenAppointmentModal()
  const isCheck = getIsCheck()
  const targetDivRef = useRef(null)
  const laboratoryDivRef = useRef(null)
  const evaluationDivRef = useRef(null)
  const queueSlipRef = useRef(null)
  // const targetLabDivRef = useRef(null);
  const navigateto = useNavigate()
  const { state } = useLocation()
  const { id } = useParams()
  const [selectedCheckUpTab, setSelectedCheckUpTab] = useState("checkup")
  const [showDelete, setShowDelete] = useState(false)
  const [showNoQueueModal, setShowNoQueueModal] = useState(false)
  const [skipQueueLoading, setSkipQueueLoading] = useState(false)
  const [showCheckupTabs, setShowCheckupTabs] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [patientDetails, setpatientDetails] = useState([])
  const [selectedTab, setSelectedTab] = useState("")
  const [selectedLabTab, setSelectedLabTab] = useState("cardiology")
  const [selectedFormTab, setSelectedFormTab] = useState("medical_cert")
  const [selectedPhilHealthTab, setSelectedPhilHealthTab] =
    useState("medical_record")
  const [isClicked, setIsClicked] = useState(false)
  const [showAppointmentModal, setShowAppointmentModal] = useState(false)
  const [showAddToQueueModal, setShowAddToQueueModal] = useState(false)
  const [selectedDoctor, setSelectedDoctor] = useState(null)
  const [doctors, setDoctors] = useState([])
  const [complaint, setComplaint] = useState("")
  const [hasPriorAssessment, setHasPriorAssessment] = useState(false)
  const [assessment, setAssessment] = useState({})
  const [queueInfo, setQueueInfo] = useState({})
  const [appointmentDate, setAppointmentDate] = useState(
    new Date(getTomorrowDate()).toISOString().split("T")[0]
  )
  const [isForConsultation, setIsForConsultation] = useState("no")
  const [hasQueued, setHasQueued] = useState(false)
  const [isQueueChecking, setIsQueueChecking] = useState(false)

  const [showRoutingSlipModal, setShowRoutingSlipModal] = useState(false)
  const [bookingResponse, setBookingResponse] = useState(null)
  const [enableAddToQueue, setEnableAddToQueue] = useState(false)
  const [printQueueNo, setPrintQueueNo] = useState("")
  const [isCreatingPayment, setIsCreatingPayment] = useState(false)
  const enableAddToQueueRef = useRef(false)
  const queueNoFromConsultRef = useRef(null)
  const queueIdFromConsultRef = useRef(null)
  const isSkipQueueFlowRef = useRef(false)
  const [canShowAddToQueue, setCanShowAddToQueue] = useState(false) // Track if allowed to show Add to Queue button
  const [queueActionDone, setQueueActionDone] = useState(false)

  const [showLabForm, setShowLabForm] = useState(false)
  const [allergyData, setAllergyData] = useState([])
  const [smokingData, setSmokingData] = useState([])
  const [showEvalForm, setShowEvalForm] = useState(false)
  const [addEvaluation, setAddEvaluation] = useState(null)
  const [autoOpenEvaluation, setAutoOpenEvaluation] = useState(false)
  const [labCategories, setLabCategories] = useState([])
  const [keepBirForm, setKeepBirForm] = useState(false);
  const [hasCompletedMedicalHistory, setHasCompletedMedicalHistory] = useState(false)
  const [hasCompletedFamilyHistory, setHasCompletedFamilyHistory] = useState(false)
  const [hasCompletedSocialHistory, setHasCompletedSocialHistory] = useState(false)

  async function checkHistoryCompletionStatus() {
    const [medSummary, socialSummary, pastMed, heredofamilial] = await Promise.all([
      getMedicalHistorySummary(id),
      getSocialPersonalHistorySummary(id),
      getPastMedicalHistory({ patient_id: id }),
      getHeredofamilial({ patient_id: id }),
    ])

    const medSummaryData = medSummary.data?.data || []
    const hasMedicalFromSummary = medSummaryData.some(
      (m) => !FAMILY_PROFILE_NAMES.has(m.name)
    )
    const hasPastMed = (pastMed.data?.data || []).length > 0
    setHasCompletedMedicalHistory(hasMedicalFromSummary || hasPastMed)

    const hasFamilyFromSummary = medSummaryData.some((m) =>
      FAMILY_PROFILE_NAMES.has(m.name)
    )
    const hasHeredofamilial = (heredofamilial.data?.data || []).length > 0
    setHasCompletedFamilyHistory(hasFamilyFromSummary || hasHeredofamilial)

    const socialData = socialSummary.data?.data || []
    const hasSocial = socialData.some((m) => SOCIAL_PROFILE_NAMES.has(m.name))
    setHasCompletedSocialHistory(hasSocial)
  }

  const handleShowLabForm = (data) => {
    setShowLabForm(data)
  }
  // Then in your component
  const [medicalHistory] = useLocalStorage("medicalHistory", "")
  const [chiefComplaint] = useLocalStorage("chiefComplaint", "")
  const [showPrintEkasModal, setShowPrintEkasModal] = useState(false);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState([]);
  //Function that will redirect you to edit profile
  function handleEdit() {
    navigateto("/patients/edit/" + id)
  }

  //Function that will delete the profile API
  async function handleDeletePatient() {
    const response = await deletePatient(id)
    if (response.data?.status === 200) {
      toast.success(response.data.data[0])
      setShowDelete(false)
      setTimeout(function () {
        navigateto("/patients")
      }, 1000)
    } else {
      toast.error(response.error.data.response)
    }
  }

  // Function get for patient API
  async function fetchPatient() {
    setIsLoading(true)
    // Only reset queue states if NOT coming from Consult button
    if (!queueNoFromConsultRef.current) {
      setEnableAddToQueue(true)
      enableAddToQueueRef.current = true
      setHasQueued(false)
      setBookingResponse(null)
    }
    
    const response = await getPatientID(id, "", "")
    if (response?.data) {
      const patient = response?.data?.data[0]

      const address = [
        patient?.street,
        patient?.barangay,
        patient?.province,
        patient?.city,
        patient?.zip_code,
      ]
        .filter(Boolean) // remove null/undefined/empty values
        .join(", ")

      setpatientDetails({
        ...patient,
        address,
      })
    } else {
      setpatientDetails([])
    }
    setIsLoading(false)
  }

  // Function for adding schedule of patient API
  const onSetAppointment = async () => {
    setIsClicked(true)
    const res = await createSchedule({
      patient_id: id,
      scheduled_on: appointmentDate,
      doctor_id: selectedDoctor !== null ? selectedDoctor : "",
    })
    if (res.data) {
      toast.success(res.data.message)
      setShowAppointmentModal(false)
    } else if (res.error) {
      toast.error(res.error.data.messages.error_messages[0])
    }
    setIsClicked(false)
  }

  // Function for adding patient to queue
  const onAddToQueue = async (action, doctorId, masterDoctorId, doctorName) => {
    if (isClicked || (!enableAddToQueue && hasQueued)) return
    
    // Get the current queue being served from localStorage (set by Dashboard)
    const currentQueueStr = localStorage.getItem("queue_id")
    const currentQueue = currentQueueStr ? JSON.parse(currentQueueStr) : null
    
    // Use queue_id from Consult button if available, otherwise from localStorage
    const queueIdToUse = queueIdFromConsultRef.current || currentQueue?.id || ""
    const queueNoToUse = queueNoFromConsultRef.current || currentQueue?.queue_no || ""
    
    if (action === "proceed") {
      setIsClicked(true)
      try {
        // Step 1: Create Queue (pass the current queue_id to link/end it)
        const queueRes = await createBookings({
          patient_id: id,
          doctor_id: doctorId,
          master_doctor_id: masterDoctorId,
          doctor_name: doctorName,
          queue_id: queueIdToUse, // Pass queue_id from Consult or localStorage
        })
        
        if (queueRes?.data) {
          // Step 2: Set FPE Done
          await setFPEDone({ patient_id: id, action: " " })
          
          // Clear the queue_id from localStorage so dashboard refreshes
          localStorage.removeItem("queue_id")
          queueIdFromConsultRef.current = null
          queueNoFromConsultRef.current = null
          setEnableAddToQueue(false)
          enableAddToQueueRef.current = false
          setQueueActionDone(true)
          setQueueInfo({})
          
          toast.success(queueRes.data.message || "Patient queued successfully")
          setHasQueued(true)
          
          if (patientDetails?.master_patient_id) {
            try {
              window.localStorage.setItem(
                `csrQueued:${patientDetails.master_patient_id}`,
                JSON.stringify(true)
              )
            } catch (e) {}
          }
          
          setShowAddToQueueModal(false)
          
          // Step 3: Show Routing Slip Modal after successful booking
          setBookingResponse({
            ...queueRes.data,
            doctor_name: doctorName, // Ensure doctor name is preserved for Routing Slip
            queue_no: queueRes?.data?.data?.queue_no || queueRes?.data?.queue_no || queueNoToUse, // Robust queue_no check
            queue_id: queueIdToUse, // Include queue_id from Consult
          })
          setShowRoutingSlipModal(true)
        } else if (queueRes?.error) {
          toast.error(
            queueRes?.error?.data?.messages?.error_messages?.[0] || "An error occurred creating queue"
          )
        }
      } catch (error) {
        toast.error("An error occurred during queue process")
      }
      setIsClicked(false)
    } else if (action === "no") {

      try {
        // Step 1: Set FPE Done
        await setFPEDone({ patient_id: id, action: "skip" })
        
        // Clear the queue_id from localStorage so dashboard refreshes
        localStorage.removeItem("queue_id")
        queueIdFromConsultRef.current = null
        queueNoFromConsultRef.current = null
        setEnableAddToQueue(false)
        enableAddToQueueRef.current = false
        setQueueActionDone(true)
        setQueueInfo({})
        
        toast.success("Queue ended and FPE marked as done")
        setHasQueued(true) // Disable Add to Queue button after "No" action
        setShowAddToQueueModal(false)
      } catch (error) {
        toast.error("An error occurred")
      }
    }
  }

  const getTodayDateString = () => new Date().toISOString().split("T")[0];

  const getBookingField = (...keys) => {
    const sources = [
      bookingResponse?.data?.data,
      bookingResponse?.data,
      bookingResponse,
    ];
    for (const source of sources) {
      if (!source || typeof source !== "object") continue;
      for (const key of keys) {
        const value = source[key];
        if (value !== undefined && value !== null && value !== "") {
          return value;
        }
      }
    }
    return "";
  };

  const getBookingAssessmentId = () => {
    const directId = getBookingField("assessment_id");
    if (directId) return directId;
    const assessment = getBookingField("assessment");
    if (assessment && typeof assessment === "object" && assessment.id) {
      return assessment.id;
    }
    return "";
  };

  const applyEkasFallbackDefaults = (details) => {
    const base = details && typeof details === "object" ? { ...details } : {};
    const bookingTransactionNo = getBookingField("transaction_no");
    const bookingCaseNo = getBookingField("phic_case_no", "case_no");

    return {
      ...base,
      phic_date_performed: base.phic_date_performed || getTodayDateString(),
      phic_performed_by: base.phic_performed_by || "Clinica Prime",
      transaction_no: base.transaction_no || bookingTransactionNo,
      phic_case_no: base.phic_case_no || bookingCaseNo,
    };
  };

  const openEkasPrintModal = async () => {
    // Prefer assessment_id from the just-created booking to avoid stale history
    let assessmentId = getBookingAssessmentId();

    if (!assessmentId) {
      try {
        const res = await getAssessmentHistory({ patient_id: id });
        assessmentId = res?.data?.data?.[0]?.id || "";
      } catch (err) {
        console.log("No assessment found, proceeding without assessment_id");
      }
    }

    const printPayload = {
      patient_id: id,
      ...(assessmentId && { assessment_id: assessmentId }),
    };

    const response = await getAssessmentForPrint(printPayload);

    let ekasDetails = response?.data?.data ?? {};
    ekasDetails = applyEkasFallbackDefaults(ekasDetails);

    setSelectedPatientDetails(ekasDetails);
    setTimeout(() => {
      setShowPrintEkasModal(true);
    }, 300);
  };

  const handlePostEkasFlow = async () => {
    setKeepBirForm(false);
    if (isSkipQueueFlowRef.current) {
      isSkipQueueFlowRef.current = false;
      setHasQueued(true);
      navigateto("/dashboard");
      return;
    }
    setIsCreatingPayment(true);
    try {
      await handleCreatePayment("no");
    } finally {
      setIsCreatingPayment(false);
    }
  };

  // Handler for when routing slip print is done - show eKas modal
  const handleRoutingSlipPrintDone = async () => {
    setShowRoutingSlipModal(false);
    isSkipQueueFlowRef.current = false;
    await openEkasPrintModal();
  };

  const handlePrintEkasThenPayment = async () => {
    setShowPrintEkasModal(false);
    setIsCreatingPayment(true);
    try {
      await handleCreatePayment("no");
    } finally {
      setIsCreatingPayment(false);
    }
  };

  // Handler for creating payment
  const handleCreatePayment = async (additionalTransaction) => {
    setIsClicked(true)
    try {
      // Build items array from booking data
      const bookings = bookingResponse?.data?.bookings || bookingResponse?.bookings || []
      const consultationBooking = bookings.find(item => 
        item.details_type === "consultation" || item.transaction_type === "consultation"
      )
      
      const items = consultationBooking ? [{
        name: `Consultation Fee ( ${consultationBooking.doctor_name || "Doctor"} )`,
        quantity: 1,
        price: consultationBooking.price || consultationBooking.amount || 0,
        amount: consultationBooking.price || consultationBooking.amount || 0,
      }] : []
      
      const totalAmount = items.reduce((sum, item) => sum + item.amount, 0)
      const transactionId = bookingResponse?.data?.transaction_id || bookingResponse?.transaction_id || ""
      const transactionNo = bookingResponse?.data?.transaction_no || bookingResponse?.transaction_no || ""
      const customerName = `${patientDetails?.first_name || ""} ${patientDetails?.middle_name || ""} ${patientDetails?.last_name || ""}`.trim()
      
      const paymentPayload = {
        patient_id: id,
        master_patient_id: patientDetails?.master_patient_id || "",
        transaction_id: transactionId,
        amount_and_types: [{ type: "cash", amount: 0.0 }],
        grand_total: 0.0,
        discount: 0.0,
        payment_discount: 0.0,
        change: 0.0,
        charge_to: "",
        is_senior: 0,
        is_pwd: 0,
        additional_transaction: additionalTransaction,
      }
      
      const paymentRes = await createPayment(paymentPayload)
      
      if (paymentRes?.data) {
        toast.success(paymentRes.data.message || "Queue successfully")
        
        // Generate receipt after successful payment
        // Priority: payment response emr_queue_no -> createBookings -> other sources
        const queueNo = paymentRes?.data?.emr_queue_no ||
                        paymentRes?.data?.emr_response?.queue_no ||
                        paymentRes?.data?.emr_response?.queue_number ||
                        paymentRes?.data?.queue_no || 
                        bookingResponse?.queue_no || 
                        queueInfo?.queue_number || 
                        queueNoFromConsultRef.current || 
                        ""
        
        console.log("generateReceipt check:", { 
          paymentResData: paymentRes?.data,
          bookingResponse, 
          queueInfo, 
          queueNoFromConsultRef: queueNoFromConsultRef.current,
          queueNo 
        })
        
        if (queueNo) {
          console.log("Calling handleApiPrint with queue_no:", queueNo)
          setPrintQueueNo(queueNo) // Set queue number for QueueSlip component
          
          // Wait for queue slip to render then print
          await new Promise(resolve => setTimeout(resolve, 1000)) // 1 second delay like working code
          
          // Use handleApiPrint like working code
          const paymentData = {
            emr_queue_no: queueNo
          }
          
          const receiptRes = await handleApiPrint(
            queueSlipRef, 
            "Cashier", 
            0, 
            'queueSlip.txt', 
            paymentData, 
            false, 
            []
          )
          
          if (receiptRes?.data) {
            console.log("Receipt generated successfully:", receiptRes.data)
          } else if (receiptRes?.error) {
            console.error("Receipt generation failed:", receiptRes.error)
            toast.error("Failed to print queue slip")
          }
        } else {
          console.log("No queue number found, skipping generateReceipt")
        }
        
        if (additionalTransaction === "yes") {
          // Enable Add to Queue button for new transaction
          setEnableAddToQueue(true)
          enableAddToQueueRef.current = true
          setHasQueued(false)
        } else {
          // Disable Add to Queue button and redirect to dashboard
          setEnableAddToQueue(false)
          enableAddToQueueRef.current = false
          navigateto("/dashboard")
        }
      } else if (paymentRes?.error) {
        toast.error(
          paymentRes?.error?.data?.messages?.error_messages?.[0] || "An error occurred creating payment"
        )
      }
    } catch (error) {
      toast.error("An error occurred during payment creation")
    }
    setIsClicked(false)
  }

    // Function for get Assessment API
  async function fetchAssessmentHistory(data) {
    const res = await getAssessmentHistory({
      patient_id: id,
      ...data,
    })
    if (res.data) {
      setAssessment(res.data.data[0])
    } else if (res.error) {
      setAssessment({})
    }
  }

  // Function to check if the patient has a pending assessment API
  async function checkIfPatientHasPriorAssessment() {
    const res = await getAssessmentHistory({
      patient_id: id,
    })
    if (res.data) {
      if (res.data.data.length > 0) {
        setHasPriorAssessment(true)
      } else {
        setHasPriorAssessment(false)
      }
    } else if (res.error) {
      setHasPriorAssessment(false)
    }
  }

  // Function for getting the queue number of patient API
  async function fetchQueueNumber() {
    setIsQueueChecking(true)
    if (state?.fromConsult) {
      setQueueInfo({})
      setHasQueued(false)
      setIsQueueChecking(false)
      return
    }
    const res = await getQueuedPatients({
      status: "queued",
      patient_id: id,
    })
    if (res?.data?.data?.length > 0) {
      setQueueInfo(res.data.data[0])
      // Only set hasQueued if enableAddToQueue is false (not allowing new transaction)
      if (!enableAddToQueueRef.current) {
        setHasQueued(true)
      }
      setIsQueueChecking(false)
      return
    }
    const res2 = await getQueuedPatients({
      status: "queued",
      patient_id: id,
      is_phic_member: 1,
    })
    if (res2?.data?.data?.length > 0) {
      setQueueInfo(res2.data.data[0])
      // Only set hasQueued if enableAddToQueue is false (not allowing new transaction)
      if (!enableAddToQueueRef.current) {
        setHasQueued(true)
      }
      setIsQueueChecking(false)
      return
    }
    setQueueInfo({})
    try {
      const flag =
        patientDetails?.master_patient_id &&
        JSON.parse(
          window.localStorage.getItem(
            `csrQueued:${patientDetails.master_patient_id}`
          ) || "false"
        )
      if (flag && !enableAddToQueueRef.current) {
        setHasQueued(true)
      } else {
        setHasQueued(false)
      }
    } catch (e) {
      setHasQueued(false)
    }
    setIsQueueChecking(false)
  }

  // Function for get Allergy API
  async function fetchAllergy() {
    const response = await getAllergy({ patient_id: id })
    if (response.data) {
      setAllergyData(response.data.data)
    } else {
      setAllergyData([])
    }
  }

  // Function for get all doctors API
  async function fetchAllDoctors() {
    const response = await getAllDoctors()
    if (response.data) {
      const mappedDoctors = response.data.data.map((doctor) => ({
        label: doctor.doctor_name,
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name,
      }))
      setDoctors(mappedDoctors)
      // setDoctors(response.data.data);
    } else {
      setDoctors([])
    }
  }

    async function fetchLabCategories() {
    const res = await getLabCategoriesQR();
    if (res.data) {
      var result = res.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
        tab_label: item.name.toLowerCase(),
      }));
      setLabCategories(result);
    } else if (res.error) {
      setLabCategories([]);
    }
  }

  useEffect(() => {
    // Check if coming from Register Patient, Consult, or PhilHealth check flow
    const isFromRegisterPatient = state?.fromRegisterPatient === true
    const isFromConsult = state?.fromConsult === true
    const isFromPhilhealthCheck = state?.fromPhilhealthCheck === true
    const hasQueueInfo = state?.queue_no && state?.queue_id
    
    // Only show Add to Queue if coming from Register Patient, Consult, or PhilHealth check flow
    if (isFromRegisterPatient || isFromConsult || isFromPhilhealthCheck) {
      setCanShowAddToQueue(true)
    } else {
      setCanShowAddToQueue(false)
    }
    
    // Capture queue info from Consult button navigation FIRST (before fetchPatient)
    if (hasQueueInfo) {
      queueNoFromConsultRef.current = state.queue_no
      queueIdFromConsultRef.current = state.queue_id
      // Enable Add to Queue when coming from Consult button with queue info
      setEnableAddToQueue(true)
      enableAddToQueueRef.current = true
      setHasQueued(false)
      setQueueInfo({}) // Clear existing queue info to show Add to Queue button
    }
    
    fetchAllDoctors()
    checkIfPatientHasPriorAssessment()
    fetchPatient()
    fetchAllergy()
    fetchLabCategories()
    checkHistoryCompletionStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  // Fetch queue number only if NOT coming from Consult button
  useEffect(() => {
    if (patientDetails?.master_patient_id && !queueNoFromConsultRef.current) {
      fetchQueueNumber()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientDetails?.master_patient_id])
  useEffect(() => {
    if (isCheck) {
      setShowCheckupTabs(true)
    }
    fetchAssessmentHistory({ status: "ongoing" })
    setShowAppointmentModal(openAppointment)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheck, openAppointment])

  useEffect(() => {
    if (!isLoading && showCheckupTabs) {
      targetDivRef.current?.scrollIntoView({ behavior: "smooth" })
    } else if (!isLoading && showLabForm) {
      laboratoryDivRef.current?.scrollIntoView({ behavior: "smooth" })
    } else if (!isLoading && showEvalForm) {
      evaluationDivRef.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [showCheckupTabs, showLabForm, showEvalForm, isLoading])

  function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => {
      try {
        const item = window.localStorage.getItem(key)
        return item ? JSON.parse(item) : initialValue
      } catch (error) {
        return initialValue
      }
    })

    useEffect(() => {
      window.localStorage.setItem(key, JSON.stringify(value))
    }, [key, value])

    return [value, setValue]
  }

  useEffect(() => {
    if (role === "nurse") {
      setSelectedTab("medical_history")
    } else if (role !== "nurse" && medicalHistory === "medical_history") {
      setSelectedTab("medical_history")
    } else {
      setSelectedTab("assessment_history")
    }
  }, [role, medicalHistory])

  useEffect(() => {
    if (state?.fromQueueCheckUp) {
      setSelectedTab("assessment_history")
      setShowCheckupTabs(true)
    }
  }, [state])

  useEffect(() => {
    if (state?.openTab === "pe_history" || state?.selectedTab === "physical_exam") {
      setSelectedTab("physical_exam")
    } else if (state?.selectedTab) {
      setSelectedTab(state.selectedTab)
    }
  }, [state?.openTab, state?.selectedTab])

  useEffect(() => {
    // for fpe
    if (
      chiefComplaint &&
      chiefComplaint !== "" &&
      medicalHistory === "medical_history"
    ) {
      setComplaint(chiefComplaint)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiefComplaint])

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )

  const isYoungChild = patientDetails?.birthdate && getAge(patientDetails.birthdate) <= 5

  return (
    <div className="App">
      <SidebarMenu active={"Patients"} />
      {isLoading || isCreatingPayment ? (
        <div className="row p-5 pt-5 ps-3 mt-5 quill-cont">
          <TableSpinner />
        </div>
      ) : (
        <div className="col p-5 py-4 profile-container">
          <Row className="pt-2 p-3 patient-header">
            <Col xs={4} className="mt-2 patient-details">
              <Row>
                <Col xs={1}>
                  <img
                    src={backarrow}
                    alt="back"
                    className="backarrow"
                    width={25}
                    height={25}
                    onClick={() => navigateto(-1)}
                  ></img>
                </Col>
                <Col className="font-big font-bold ms-4 patient-details-title">
                  PATIENT DETAILS
                </Col>
              </Row>
            </Col>
            <Col xs={1}></Col>
            <Col className="">
              <Row className="profile-button buttons-payment">
                {!queueActionDone && (queueInfo.id || queueInfo.queue_number) && (
                  <Col className="header-btn">
                    <BtnSave
                      label={`Queue # ${queueInfo.queue_number}`}
                      disabled
                    />
                  </Col>
                )}
                <Col className="header-btn">
                  {canShowAddToQueue ? (
                    <BtnSave
                      label={"Add to Queue"}
                      onClick={() => setShowAddToQueueModal(true)}
                      disabled={                        
                      isClicked || 
                      isQueueChecking || 
                      queueActionDone ||
                      (!enableAddToQueue && hasQueued) ||
                      (!isYoungChild && (!hasCompletedMedicalHistory || !hasCompletedFamilyHistory || !hasCompletedSocialHistory))
                    }
                    />
                  ) : null}
                </Col>
                <Col className="header-btn">
                  <BtnSave
                    label={"Done"}
                    onClick={() => setShowNoQueueModal(true)}
                    disabled={
                      queueActionDone ||
                      (!isYoungChild && (!hasCompletedMedicalHistory || !hasCompletedFamilyHistory || !hasCompletedSocialHistory))
                    }
                  />
                </Col>

                {role !== "nurse" && (
                  <Col className="header-btn">
                    {patientDetails?.assessment?.length !== 0 ? (
                      <BtnSave
                        label={"Cont. Check Up"}
                        onClick={() => {
                          setShowCheckupTabs(!showCheckupTabs)
                          setShowLabForm(false)
                          fetchAssessmentHistory({ status: "ongoing" })
                        }}
                      />
                    ) : (
                      <>
                        {medicalHistory === "" && (
                          <BtnSave
                            label={"Check Up"}
                            onClick={() => {
                              setShowCheckupTabs(!showCheckupTabs)
                              setShowLabForm(false)
                              fetchAssessmentHistory({ status: "ongoing" })
                            }}
                          />
                        )}
                      </>
                    )}
                  </Col>
                )}
              </Row>
            </Col>
          </Row>

          <Row>
            {/* PATIENT INFO */}
            <Col xl={2} className="profile-pic mb-4">
              <PatientCard
                patientDetails={patientDetails}
                onEditClick={handleEdit}
                onDeleteClick={() => setShowDelete(true)}
              />
              <AllergyCard allergyData={allergyData} />
            </Col>

            {/* PATIENT TABS */}
            <Col
              xl={10}
              align="right"
              className="profile-tab card-container medical-summary-pdf"
            >
              <Tabs
                activeKey={selectedTab}
                id="PO-tabs"
                type="card"
                animated="true"
                size="large"
                onChange={(e) => {
                  setSelectedTab(e)
                }}
              >
                <TabPane
                  key="social_personal_history"
                  tab="Social/Personal History"
                >
                  {selectedTab === "social_personal_history" && (
                    <AddSocialPersonal
                      smokingDatas={smokingData}
                      setSmokingDatas={setSmokingData}
                      refreshHistoryCompletion={checkHistoryCompletionStatus}
                    />
                  )}
                </TabPane>
                <TabPane key="medical_history" tab="Medical History">
                  {selectedTab === "medical_history" && (
                    <AddMedical
                      allergyData={allergyData}
                      setAllergyData={setAllergyData}
                      refreshHistoryCompletion={checkHistoryCompletionStatus}
                    />
                  )}
                </TabPane>
                <TabPane key="vital_signs" tab="Vital Signs">
                  {selectedTab === "vital_signs" && (
                    <VitalSigns
                      id={id}
                      sex={patientDetails.sex}
                      patientDetails={patientDetails}
                    />
                  )}
                </TabPane>
                <TabPane key="physical_exam" tab="Physical Exam">
                  {selectedTab === "physical_exam" && (
                    <PhysicalExaminationYakap
                      patientDetails={patientDetails}
                      viewOnly={true}
                    />
                  )}
                </TabPane>
                <TabPane key="health_screening" tab="Health Screening">
                  {selectedTab === "health_screening" && (
                    <HealthScreening patientId={id} />
                  )}
                </TabPane>
                {role !== "nurse" && (
                  <>
                    <TabPane key="assessment_history" tab="Assessments">
                      {selectedTab === "assessment_history" && (
                        <AssessmentHistory patientId={id} />
                      )}
                    </TabPane>
                  </>
                )}
                {/* {role !== "nurse" && ( */}
                  <>
                    <TabPane key="lab_results" tab="Lab Results">
                      {selectedTab === "lab_results" && (
                        <LaboratoryResults
                          showEvalForm={(val) => setShowEvalForm(val)}
                          showLabForm={(val) => setShowLabForm(val)}
                          setShowCheckupTabs={(val) => setShowCheckupTabs(val)}
                          setAddEvaluation={(val) => setAddEvaluation(val)}
                          patientId={id}
                          autoOpenEvaluation={autoOpenEvaluation}
                        />
                      )}
                    </TabPane>
                  </>
                {/* )} */}
                {role !== "nurse" && (
                  <>
                    <TabPane key="therapeutics" tab="Therapeutics">
                      {selectedTab === "therapeutics" && (
                        <TheraputicsHistory patientId={id} />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="scanned_files" tab="Scanned Files">
                      {selectedTab === "scanned_files" && (
                        <PatientScannedProfile
                          patientId={id}
                          patientDetails={patientDetails}
                        />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="forms" tab="Forms">
                      {selectedTab === "forms" && (
                        <Card>
                          {hasPriorAssessment ? (
                            <div style={{ minHeight: "100%" }}>
                              <div className="row">
                                <Tabs
                                  activeKey={selectedFormTab}
                                  id="PO-tabs"
                                  type="card"
                                  animated="true"
                                  size="large"
                                  onChange={(e) => {
                                    setSelectedFormTab(e)
                                  }}
                                >
                                  <TabPane
                                    key="medical_cert"
                                    tab="Medical Certificate"
                                  >
                                    {selectedFormTab === "medical_cert" && (
                                      <MedicalCertificateForm
                                        fileName={"MedicalCertificate.pdf"}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="referral_letter"
                                    tab="Referral Letter"
                                  >
                                    {selectedFormTab === "referral_letter" && (
                                      <ReferralLetterForm
                                        fileName={"ReferralLetter.pdf"}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="medical_abstract"
                                    tab="Medical Abstract"
                                  >
                                    {selectedFormTab === "medical_abstract" && (
                                      <MedicalAbstract
                                        id={id}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="medical_summary"
                                    tab="Medical Summary"
                                  >
                                    {selectedFormTab === "medical_summary" && (
                                      <MedicalSummary
                                        id={id}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="form_history"
                                    tab="Form History"
                                  >
                                    {selectedFormTab === "form_history" && (
                                      <FormHistory patientId={id} />
                                    )}
                                  </TabPane>
                                </Tabs>
                              </div>
                            </div>
                          ) : (
                            <Alert
                              variant="warning"
                              className="d-flex align-items-center"
                            >
                              <FontAwesomeIcon
                                fontSize={24}
                                icon={faCircleExclamation}
                              />
                              <span className="px-3">
                                Sorry, but you cannot generate medical forms for
                                a patient without prior assessment history.
                              </span>
                            </Alert>
                          )}
                        </Card>
                      )}
                    </TabPane>
                  </>
                )}
                <TabPane key="philhealth" tab="PhilHealth">
                  {selectedTab === "philhealth" && (
                    <Card>
                      <div style={{ minHeight: "100%" }}>
                        <div className="row">
                          <Tabs
                            activeKey={selectedPhilHealthTab}
                            id="PO-tabs"
                            type="card"
                            animated="true"
                            size="large"
                            onChange={(e) => {
                              setSelectedPhilHealthTab(e)
                            }}
                          >
                            <TabPane key="medical_record" tab="Medical Record">
                              {selectedPhilHealthTab === "medical_record" && (
                                <PhilHealthMedicalRecord
                                  patientDetails={patientDetails}
                                />
                              )}
                            </TabPane>
                            <TabPane key="konsulta" tab="eKonsulta">
                              {selectedPhilHealthTab === "konsulta" && (
                                <KonsultaManager
                                  patientDetails={patientDetails}
                                />
                              )}
                            </TabPane>
                          </Tabs>
                        </div>
                      </div>
                    </Card>
                  )}
                </TabPane>
                {role !== "nurse" && (
                  <>
                    <TabPane key="medical_chart" tab="Medical Chart">
                      {selectedTab === "medical_chart" && (
                        <MedicalChart patientDetails={patientDetails} />
                      )}
                    </TabPane>
                  </>
                )}
              </Tabs>
            </Col>
            {showCheckupTabs && role !== "nurse" && (
              <div ref={targetDivRef}>
                <CheckupTabs
                  assessment={assessment}
                  fetchAssessmentHistory={() =>
                    fetchAssessmentHistory({ status: "ongoing" })
                  }
                  complaint={state?.complaint || ""}
                  doctor_id={state?.doctor_id || ""}
                  selectedCheckUpTab={selectedCheckUpTab}
                  setSelectedCheckUpTab={setSelectedCheckUpTab}
                  patientDetails={patientDetails}
                  doctorOptions={doctors}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  selectedFormTab={selectedFormTab}
                  setSelectedFormTab={setSelectedFormTab}
                />
              </div>
            )}

            {showLabForm && selectedTab === "lab_results" && (
              <div
                ref={laboratoryDivRef}
                className="col card-container three-buttons-labaratory"
              >
                <Tabs
                  activeKey={selectedLabTab}
                  id="PO-tabs"
                  type="card"
                  size="large"
                  onChange={(e) => setSelectedLabTab(e)}
                >
                  {labCategories.map((data) => (
                    <TabPane key={data.tab_label} tab={data.name}>
                      <LabResultPage
                        id={id}
                        showLabForm={handleShowLabForm}
                        categoryData={data}
                      />
                    </TabPane>
                  ))}
                  <TabPane key="other" tab="OTHERS">
                    {selectedLabTab === "other" && (
                      <Others id={id} showLabForm={handleShowLabForm} />
                    )}
                  </TabPane>
                </Tabs>
              </div>
            )}
          </Row>
          {/* <div className="mb-5"></div> */}
        </div>
      )}
      <AppointmentModal
        title={`Set Appointment Date`}
        show={showAppointmentModal}
        onHide={() => setShowAppointmentModal(false)}
        doctorsData={doctors}
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor} // Pass function to update doctor
        onConfirm={onSetAppointment}
        defaultDate={appointmentDate}
        setRescheduledDate={setAppointmentDate}
        saveTitle={`Save`}
        isClicked={isClicked}
      />
      {/* <AddToQueueModal
        patientId={id}
        show={showAddToQueueModal}
        onHide={() => {
          setComplaint("");
          setShowAddToQueueModal(false);
        }}
        complaint={complaint}
        onChange={(e) => setComplaint(e.target.value)}
        doctorsData={doctors}
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor} // Pass function to update doctor
        onConfirm={onAddToQueue}
        isClicked={isClicked}
      /> */}
      <AddToQueueModal
        patientId={id}
        show={showAddToQueueModal}
        onHide={() => setShowAddToQueueModal(false)}
        onConfirm={onAddToQueue}
        isClicked={isClicked}
      />
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={"Do you want to delete this patient?"}
        onDelete={handleDeletePatient}
        isClicked={isClicked}
      />
      {/* Confirmation Modal for No Queue */}
      <DeleteModal
        show={showNoQueueModal}
        onHide={() => setShowNoQueueModal(false)}
        title={"Are you sure you will not proceed to queue?"}
        onDelete={async () => {
          setSkipQueueLoading(true);
          try {
            await setFPEDone({ patient_id: id, action: "skip" });

            localStorage.removeItem("queue_id");
            queueIdFromConsultRef.current = null;
            queueNoFromConsultRef.current = null;
            setEnableAddToQueue(false);
            enableAddToQueueRef.current = false;
            setQueueActionDone(true);
            setQueueInfo({});

            toast.success("FPE marked as done");
            setShowNoQueueModal(false);
            setHasQueued(true);
            isSkipQueueFlowRef.current = true;
            await openEkasPrintModal();
          } catch (error) {
            toast.error("An error occurred");
          }
          setSkipQueueLoading(false);
        }}
        isClicked={skipQueueLoading}
        deleteLabel="OK"
        closeLabel="Cancel"
        hideUndoText={true}
      />
      <RoutingSlipModal
        show={showRoutingSlipModal}
        onHide={() => setShowRoutingSlipModal(false)}
        customerDetail={patientDetails}
        allBooking={bookingResponse?.data?.bookings || bookingResponse?.bookings || []}
        bookingData={bookingResponse || {}}
        transactionNo={bookingResponse?.data?.transaction_no || bookingResponse?.transaction_no || ""}
        queueNo={queueInfo?.queue_no || ""}
        onPrintDone={handleRoutingSlipPrintDone}
        isLoading={isCreatingPayment}
      />

      {/* Print eKas Confirmation Modal */}
      <Modal
        show={showPrintEkasModal}
        onHide={null} // disables close on click outside
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>Print eKas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Print the eKas form for this patient.</p>
        </Modal.Body>
        <Modal.Footer>
          {/* <BtnDelete
            label="Skip"
            size="sm"
            onClick={async () => {
              setKeepBirForm(true);
              setShowPrintEkasModal(false);
              try {
                await handleCreatePayment("no");
              } finally {
                setIsCreatingPayment(false);
              }
            }}
          /> */}
          <BtnSave
            label="Print eKas"
            size="sm"
            onClick={async () => {
              // Step 1: Keep BirForm in DOM, close modal
              setKeepBirForm(true);
              setShowPrintEkasModal(false);

              // Step 2: Wait for modal to close and DOM to settle
              await new Promise(resolve => setTimeout(resolve, 500));

              const element = document.getElementById("printablediv");

              if (!element || element.innerHTML.trim().length < 100) {
                toast.error("eKas content not ready. Please try again.");
                setKeepBirForm(false);
                await handlePostEkasFlow();
                return;
              }

              try {
                toast.loading("Processing eKas...");

                // Step 3: Create fresh div outside React tree
                const tempDiv = document.createElement("div");
                tempDiv.style.position = "fixed";
                tempDiv.style.top = "0";
                tempDiv.style.left = "0";
                tempDiv.style.zIndex = "9999";
                tempDiv.style.width = "559px";
                tempDiv.style.height = "794px";
                tempDiv.style.overflow = "hidden";
                tempDiv.style.backgroundColor = "white";
                tempDiv.innerHTML = element.innerHTML;
                document.body.appendChild(tempDiv);

                // Override bir-form styles to fit A5
                const birFormEl = tempDiv.querySelector(".bir-form");
                if (birFormEl) {
                  birFormEl.style.position = "relative";
                  birFormEl.style.width = "559px";
                  birFormEl.style.height = "774px";
                  birFormEl.style.margin = "0";
                  // birFormEl.style.overflow = "hidden";
                }

                // Override img styles
                const ekasImg = tempDiv.querySelector(".ekas-img");
                if (ekasImg) {
                  ekasImg.style.position = "absolute";
                  ekasImg.style.top = "0";
                  ekasImg.style.left = "0";
                  ekasImg.style.width = "100%";
                  ekasImg.style.height = "100%";
                  ekasImg.style.objectFit = "contain";
                }

                const overlayFields = tempDiv.querySelectorAll(
                  ".ekas-patient-hci-name, .ekas-patient-case-no, .ekas-patient-accred-no, " +
                  ".ekas-patient-transaction-no, .ekas-patient-pin, .ekas-patient-member-category, " +
                  ".ekas-patient-name, .ekas-patient-age, .ekas-patient-contact-no, " +
                  ".ekas-patient-member-type, .ekas-patient-dependent-type, .ekas-patient-atc, " +
                  ".ekas-patient-performed, .ekas-patient-date-performed, .ekas-patient-doc-name"
                );

                const mm = (val) => `${Math.round(val * 3.7795)}px`;

                const syncCheckedAttributes = (container) => {
                  const checkboxesAndRadios = container.querySelectorAll('input[type="checkbox"], input[type="radio"]');
                  checkboxesAndRadios.forEach(input => {
                    if (input.checked) {
                      input.setAttribute('checked', 'checked');
                    } else {
                      input.removeAttribute('checked');
                    }
                  });
                };

                overlayFields.forEach(el => {
                  el.style.position = "absolute";
                  el.style.display = "inline-block";
                  el.style.boxSizing = "border-box";
                  el.style.overflow = "hidden";
                  el.style.fontSize = "8pt";
                  el.style.margin = "0";
                  el.style.padding = "0";
                });

                const nameEl = tempDiv.querySelector(".ekas-patient-name");
                if (nameEl) {
                  nameEl.style.display = "block";
                  nameEl.style.whiteSpace = "normal";
                  nameEl.style.wordBreak = "break-word";
                  nameEl.style.lineHeight = "1.15";
                  nameEl.style.fontSize = "7pt";
                  nameEl.style.maxHeight = mm(6.5);
                  nameEl.style.overflow = "hidden";
                }                
                const setPos = (cls, top, left, width) => {
                  const el = tempDiv.querySelector(cls);
                  if (el) { el.style.top = top; el.style.left = left; if (width) el.style.width = width; }
                };
                setPos(".ekas-patient-hci-name",        mm(24), mm(5),   mm(55));
                setPos(".ekas-patient-case-no",         mm(24), mm(62),  mm(24));
                setPos(".ekas-patient-accred-no",       mm(24), mm(93),  mm(25));
                setPos(".ekas-patient-transaction-no",  mm(24), mm(119), mm(26));
                setPos(".ekas-patient-pin",             mm(33), mm(5),   mm(43));
                setPos(".ekas-patient-member-category", mm(33), mm(72),  mm(37));
                setPos(".ekas-patient-name",            mm(41), mm(5),   mm(65));
                setPos(".ekas-patient-age",             mm(41), mm(78),  mm(9));
                setPos(".ekas-patient-contact-no",      mm(41), mm(98),  mm(28));
                setPos(".ekas-patient-member-type",     mm(48), mm(26),  null);
                setPos(".ekas-patient-dependent-type",  mm(48), mm(45),  null);
                setPos(".ekas-patient-atc",             mm(50), mm(78),  mm(28));
                setPos(".ekas-patient-performed",       mm(66), mm(92),  null);
                setPos(".ekas-patient-date-performed",  mm(66), mm(107), mm(16));
                setPos(".ekas-patient-doc-name",        mm(66), mm(126), mm(20));

                const autoShrinkMultilineToFit = (el, maxWidthPx, maxHeightPx, maxFontPt = 7, minFontPt = 5) => {
                  if (!el) return;
                  el.style.display = "block";
                  el.style.whiteSpace = "normal";
                  el.style.wordBreak = "break-word";
                  el.style.width = `${maxWidthPx}px`;
                  el.style.maxWidth = `${maxWidthPx}px`;
                  el.style.maxHeight = `${maxHeightPx}px`;
                  el.style.overflow = "hidden";
                  el.style.lineHeight = "1.15";

                  let fontSize = maxFontPt;
                  el.style.fontSize = `${fontSize}pt`;
                  while (el.scrollHeight > maxHeightPx && fontSize > minFontPt) {
                    fontSize -= 0.25;
                    el.style.fontSize = `${fontSize}pt`;
                  }
                };

                autoShrinkMultilineToFit(tempDiv.querySelector(".ekas-patient-case-no"), parseInt(mm(24)), parseInt(mm(6)), 6.5, 5);
                autoShrinkMultilineToFit(tempDiv.querySelector(".ekas-patient-transaction-no"), parseInt(mm(26)), parseInt(mm(8)), 6.5, 4.5);
                autoShrinkMultilineToFit(tempDiv.querySelector(".ekas-patient-name"), parseInt(mm(68)), parseInt(mm(7.5)), 6, 3.5);

                const docNameEl = tempDiv.querySelector(".ekas-patient-doc-name");
                if (docNameEl) {
                  const maxWidthPx = parseInt(mm(20));
                  docNameEl.style.display = "block";
                  docNameEl.style.whiteSpace = "nowrap";
                  docNameEl.style.width = `${maxWidthPx}px`;
                  docNameEl.style.maxWidth = `${maxWidthPx}px`;
                  docNameEl.style.overflow = "hidden";
                  let fontSize = 6;
                  docNameEl.style.fontSize = `${fontSize}pt`;
                  while (docNameEl.scrollWidth > maxWidthPx && fontSize > 3.5) {
                    fontSize -= 0.25;
                    docNameEl.style.fontSize = `${fontSize}pt`;
                  }
                }

                // Step 4: Wait for image in tempDiv to load
                const tempImg = tempDiv.querySelector("img");
                if (tempImg) {
                  await new Promise((resolve) => {
                    if (tempImg.complete && tempImg.naturalHeight !== 0) {
                      resolve();
                    } else {
                      tempImg.onload = resolve;
                      tempImg.onerror = resolve;
                      setTimeout(resolve, 3000);
                    }
                  });
                }

                await new Promise(resolve => setTimeout(resolve, 500));
                console.log("tempDiv offsetHeight:", tempDiv.offsetHeight);

                // Step 5: Generate PDF
                const pdfBlob = await html2pdf()
                  .set({
                    margin: 0,
                    filename: "ekas.pdf",
                    image: { type: "jpeg", quality: 0.98 },
                    html2canvas: { 
                      scale: 3,
                      useCORS: true, 
                      allowTaint: true,
                      backgroundColor: "#ffffff",
                      windowWidth: 559,
                      windowHeight: 794,
                      width: 559,
                      height: 794,
                    },
                    jsPDF: { 
                      unit: "px",
                      format: [559, 794],
                      orientation: "portrait",
                    },
                  })
                  .from(birFormEl)
                  .outputPdf("blob");

                // Step 6: Remove tempDiv
                document.body.removeChild(tempDiv);

                // Step 7: Download para ma-check
                const url = URL.createObjectURL(pdfBlob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "ekas_debug.pdf";
                a.click();
                URL.revokeObjectURL(url);

                // Step 8: Print the generated PDF directly (guaranteed identical to download)   <-- BAG-O DIRI
                const pdfUrlForPrint = URL.createObjectURL(pdfBlob);
                const printFrame = document.createElement("iframe");
                printFrame.style.position = "fixed";
                printFrame.style.right = "0";
                printFrame.style.bottom = "0";
                printFrame.style.width = "0";
                printFrame.style.height = "0";
                printFrame.style.border = "0";
                printFrame.src = pdfUrlForPrint;
                document.body.appendChild(printFrame);

                printFrame.onload = () => {
                  setTimeout(() => {
                    try {
                      printFrame.contentWindow.focus();
                      printFrame.contentWindow.print();
                    } catch (err) {
                      console.error("Print failed, falling back to new tab:", err);
                      window.open(pdfUrlForPrint, "_blank");
                    }
                  }, 300);
                };

                // Step 9: Upload
                const formData = new FormData();
                formData.append("file", pdfBlob, "ekas.pdf");
                formData.append("patient_id", id);
                formData.append("assessment_id", selectedPatientDetails?.assessment?.id || "");
                formData.append("document_type", "Ekas");

                const uploadRes = await uploadEkasDocument(formData);
                toast.dismiss();
                if (uploadRes?.data) {
                  toast.success("eKas uploaded successfully");
                } else {
                  toast.error("Failed to upload eKas");
                }

              } catch (err) {
                toast.dismiss();
                toast.error("Failed to process eKas");
                console.error(err);
              }

              // Step 10: Payment or skip-queue redirect
              await handlePostEkasFlow();
            }}
          />
        </Modal.Footer>
      </Modal>

      {/* Hidden BirForm for printing */}
      {(showPrintEkasModal || keepBirForm) && <BirForm data={selectedPatientDetails} />}
      {/* Hidden QueueSlip for printing */}
      <div style={{ position: "absolute", left: "-9999px", top: "-9999px", width: "520px" }}>
        <div ref={queueSlipRef} style={{ width: "520px" }}>
          <QueueSlip
            transaction_id=""
            emr_queue_no={printQueueNo}
            isCsr={true}
          />
        </div>
      </div>
    </div>
  )
}

export default PatientProfile
